import { r as i, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const s = ".sc-reply-icon-h{display:flex}", h = s, o = class {
  constructor(e) {
    i(this, e), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "695ca66d1f736e734583485385c53cfb1f6fb616", fill: "auto", width: this.width, height: this.height, viewBox: "0 0 1920 1920", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "d9a66c833ab94da7adb19fef09ff7e7a26ea61ae", d: "M835.942 632.563H244.966l478.08-478.08-90.496-90.496L-.026 696.563 632.55 1329.14l90.496-90.496-478.08-478.08h590.976c504.448 0 914.816 410.368 914.816 914.816v109.184h128V1675.38c0-574.976-467.84-1042.816-1042.816-1042.816", "fill-rule": "evenodd" }));
  }
};
o.style = h;
export {
  o as reply_icon
};
